<template>
  <div class="view__front">
    <main id="dn-article-seo">
      <article>

        <!-- content for errybody -->
        <header class="article-header">
          <single-video
            v-if="desktop"
            key="pyro-landscape"
            :webm="require('@/assets/videos/pyro-l.webm')"
            :mp4="require('@/assets/videos/pyro-l.mp4')">
          </single-video>
          <single-video
            v-else
            key="pyro-portrait"
            :webm="require('@/assets/videos/pyro-p.webm')"
            :mp4="require('@/assets/videos/pyro-p.mp4')">
          </single-video>
          <intro></intro>
        </header>

        

        
          <!-- that premium content -->

          <div class="holder">
            <div class="text">
              <case v-for="(item, i) in cases" :item="item" :index="i" :key="i"></case>
            </div>
          </div>

          <lantern
            :paging="true"
            url="https://lantern.dn.no/v1/content?sub_type=news&tags=koronaviruset&offset=0&hits=6&sort_by=first_published_at"
            :placeholderImage="require('@/assets/lantern.png')">
          </lantern>
        
      </article>
    </main>
  </div>
</template>

<script>
import Paywall from '@/components/modules/Paywall';
import SingleVideo from '@/components/modules/SingleVideo';
import Intro from '@/components/modules/Intro';
import Case from "@/components/modules/Case";
import Lantern from "@/components/modules/Lantern";
import Cases from "@/package/cases";

export default {
  components: {
    SingleVideo,
    Intro,
    Case,
    Lantern,
    Paywall,
  },
  data() {
    return {
      articleId: process.env.VUE_APP_ARTICLE_ID,
      articleUrl: process.env.VUE_APP_URL,
      cases: Cases,
      width: window.innerWidth,
    };
  },
  computed: {
    desktop() {
      return this.width >= 992;
    }
  },
  beforeMount() {
    window.addEventListener('resize', () => this.width = window.innerWidth);
  }
};
</script>

<style lang="scss">
@import "scss/dn/base";
@import "scss/dn/modules/lantern";

.view__front {
  padding: 0;

  main {
    min-height: 400px;
  }

  .holder {
    background-color: $color-white;
  }

  .text {
    display: grid;
    grid-gap: var(--spacing);
    margin-left: auto;
    margin-right: auto;
    max-width: 61.25rem;
    padding-bottom: calc(var(--spacing) * 2);
    padding-top: 0;

    @media #{$grid-lg-up} {
      grid-gap: calc(var(--spacing) * 2);
      padding-top: calc(var(--spacing) * 2);
    }

    &::after {
      background: $color-black;
      content: '';
      display: block;
      height: 1px;
      left: 50%;
      position: relative;
      transform: translateX(-50%);
      width: 5rem;
    }
  }
}
</style>